angular.module('invoice')
    .controller('AgreementBgtEditPositionController', function (data, toastr, $rootScope, $uibModalInstance, modals, Invoice, InvoiceService, AgreementBgt) {
        this.InvoiceService = InvoiceService

        this.$onInit = () => {
            this.totalLeft = data.totalLeft
            this.totalNet = data.invoiceTotal
            this.agreementId = data.agreementId
            this.revisionId = data.revisionId
            if(data.item) {
                this.item = angular.copy(data.item)
            }
            else {
                this.item = {
                    id: null,
                    amount: this.totalLeft,
                    currency: data.currency
                }
            }
            this.item.currency = data.currency || this.item.currency || 'PLN'
            this.onAmountChanged(this.item)
            this.currency = this.item.currency
        }

        this.onPercentageChanged = (c) => {
            this.item.amount = InvoiceService.multiply(this.percentage / 100, this.totalNet)
        }
        this.onAmountChanged = (c) => {
            this.percentage = InvoiceService.percentage(this.item.amount, this.totalNet) || 0
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let promise
            if (this.item.id != null) {
                promise = AgreementBgt.update({agreementId: this.agreementId, revisionId: this.revisionId}, this.item).$promise
            } else {
                promise = AgreementBgt.save({agreementId: this.agreementId, revisionId: this.revisionId}, this.item).$promise
            }
            return promise.then(result => {
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
    })
